import {
  InsuranceCoverage,
  MotorcycleCoverage,
} from "Store/interfaces/products/coverage";

import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { MotorcycleProductPriceFormValues } from "../motorcycleInterface";

export const getDeductible = (
  formValues: MotorcycleProductPriceFormValues,
): string | undefined => {
  if (formValues.coverage === MotorcycleCoverage.MOTORCYCLE_FULL_OWN_DAMAGE) {
    return formValues.deductible;
  }
  if (
    formValues.coverage === MotorcycleCoverage.MOTORCYCLE_REDUCED_OWN_DAMAGE
  ) {
    return "Se vilkår";
  }
  return "Ingen";
};

export const getAllCoveragesOrKaskoCoverage = (
  canBuyAllCoverages: boolean,
  insuranceCoverage: InsuranceCoverage,
): CoveragePriceCalculation[] => {
  const coverages = useCoveragePriceCalculations();
  const kaskoCoverage = coverages.filter(([coverage]) => {
    return coverage === insuranceCoverage;
  });
  return canBuyAllCoverages ? coverages : kaskoCoverage;
};
